import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { useZepApiClient } from '../zep-api/ZepApiProvider';

import type { InventoryResponse } from './types';

export const QUERY_KEY_EQUIPMENT_INVENTORY = 'equipment-inventory';

export function getEquipmentInventoryQueryKey(userHashId?: string | null) {
  return [QUERY_KEY_EQUIPMENT_INVENTORY, userHashId ?? null] as const;
}

export function useEquipmentInventory(options?: {
  userHashId?: string | null;
  enabled?: boolean;
  suspense?: boolean;
  staleTime?: number;
}): UseQueryResult<InventoryResponse> {
  const client = useZepApiClient();
  const { userHashId, ...queryOptions } = options ?? {};
  return useQuery<InventoryResponse>(
    getEquipmentInventoryQueryKey(userHashId),
    async () => {
      const { data } = await client.get('/equipment/inventory');
      const envelope = data?.data ?? data;
      if (envelope == null) {
        throw new Error('Equipment inventory response was empty');
      }
      return envelope as InventoryResponse;
    },
    { staleTime: 30_000, useErrorBoundary: false, ...queryOptions },
  );
}
